<template lang="pug">
v-container(pa-0 class="tw-mb-2 tw-h-full tw-w-full  ")
  v-row(dense class="tw-h-full tw-w-full")
    v-col(cols="12" class=" tw-rounded tw-overflow-hidden tw-py-1 tw-h-full")
      div(class=" tw-bg-white tw-overflow-hidden tw-rounded-md tw-border tw-border-gray-lighten-2 tw-h-full tw-w-full")
        v-row(no-gutters class="tw-h-full tw-w-full")
          v-col(cols="5" md="5" class="tw-h-full")
            v-row(no-gutters)
              v-col(pa-0 class="")
                div(class="")
                  router-link(
                    :to="{ path: `/website/listing/${this.$faker().datatype.number()}` }"
                    class="tw-font-medium text-link"
                  )
                    div(class="theme-g-listing-card-image-container")
                      v-img(:src="image" aspect-ratio="1.3")
          v-col(cols="7" class="tw-h-full")
            v-row(no-gutters class=" tw-p-0 tw-h-full")
              v-col(class="tw-h-full")
                div(class="tw-flex tw-flex-col  tw-h-full")
                  div(class="tw-flex tw-flex-col tw-flex-grow-default")
                    v-row(no-gutters align="start")
                      v-col(class="tw-m-3 tw-mb-0")
                        v-row(no-gutters align="center" class="tw-h-full")
                          v-col(cols="12")
                            div(class=" tw-overflow-hidden tw-mr-4 tw-pt-1 tw-font-medium ")
                              router-link(
                                class="tw-font-bold tw-whitespace-no-wrap "
                                :to="{ path: `/website/listing/${this.$faker().datatype.number()}` }"
                              )
                                span(class="tw-text-blueGray-darken-2") {{ this.$faker().lorem.sentence(5) }}
                            div(class=" tw-text-blueGray-darken-2 tw-text-sm ml-n1 pt-1")
                              v-icon(color=" blue-grey lighten-2" class="tw-p-0 tw-m-0") mdi-map-marker-outline
                              span(class="tw-ml-1 tw-font-bold tw-text-blueGray-lighten-2 ") {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}
                            div(class=" tw-text-blueGray-darken-2 tw-text-sm ml-n1 pt-1 pl-1")
                              span(class="tw-font-bold tw-text-blueGray-lighten-2 ") {{ this.$faker().lorem.paragraphs(1) }}
                  div(class=" tw-flex tw-flex-col tw-relative tw-h-full")
                    div(class="tw-absolute tw-bottom-0  tw-w-full")
                      v-row(no-gutters justify="start" class="tw-border-blueGray-lighten-5 tw-border-b tw-px-2 pl-2")
                        v-col(cols="auto" class=" tw-items-center tw-mb-1 ")
                          v-row(dense justify="center" class="tw-py-2")
                            v-col(cols="auto" class="tw-mr-2")
                              v-row(no-gutters align="center" justify="center")
                                v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                                  div(class=" tw-w-6 tw-h-6 tw-flex ")
                                    v-icon(small color=" blue-grey lighten-2" class="tw-mx-auto") mdi-bed-king
                                v-col(cols="auto" class=" tw-text-center")
                                  span(class="tw-ml-1  tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Beds
                            v-col(cols="auto" class="tw-mr-2")
                              v-row(no-gutters align="center" justify="center")
                                v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                                  div(class=" tw-w-6 tw-h-6 tw-flex ")
                                    v-icon(small color=" blue-grey lighten-2" class="tw-mx-auto") mdi-shower
                                v-col(cols="auto" class=" tw-text-center")
                                  span(class="tw-ml-1  tw-text-sm") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Bath

                            v-col(cols="auto" class="tw-mr-2")
                              v-row(no-gutters align="center" justify="center")
                                v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                                  div(class=" tw-w-6 tw-h-6 tw-flex ")
                                    v-icon(small color=" blue-grey lighten-2" class="tw-mx-auto") mdi-arrow-all
                                v-col(cols="auto" class=" tw-text-center")
                                  span(class="tw-ml-1  tw-text-sm") {{ this.$faker().datatype.number({ min: 200, max: 800 }) }} m <sup>2</sup>

                      v-row(no-gutters justify="space-between" align="center" class=" tw-py-3 tw-px-2")
                        v-col(cols="auto")
                          v-row(no-gutters align="center" justify="center")
                            v-col(cols="auto" class=" tw-text-center")
                              v-chip(class="tw-uppercase" color="#E8C855")
                                span(class="tw-text-blueGray-darken-3 tw-font-bold") For {{ this.$faker().random.arrayElement(['Rent', 'Sale']) }}
                        v-col(cols="auto" class=" tw-text-right  " align-self="center")
                          span(class="tw-font-bold tw-text-2xl tw-text-blueGray-darken-2") ${{ this.$faker().finance.amount(10000, 100000, 0) }}
                          span(class="tw-pl-1") /month
</template>
<script>
export default {
  data() {
    return {
      image: null,
    };
  },

  mounted() {
    this.$store.dispatch('properties/getPexelImage').then((response) => {
      this.image = response;
    });
  },
};
</script>
<style lang="scss">
.theme-g-listing-card-image-container {
  // For UHD screens set width to 560px and height to 400px
  // @media (min-width: 2500px) {
  //   width: 500px;
  //   height: auto;
  // }

  // // For HD screens set width to 460px and height to 300px
  // @media (min-width: 1920px) and (max-width: 2559px) {
  //   width: 460px;
  //   height: 300px;
  // }

  // // For MD screens set width to 360px and height to 200px
  // @media (min-width: 1280px) and (max-width: 1919px) {
  //   width: 360px;
  //   height: 200px;
  // }

  // // For SM screens set width to 260px and height to 150px
  // @media (max-width: 1279px) {
  //   width: 260px;
  //   height: 150px;
  // }
}
</style>
